import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4003030d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Compose Message", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = { class: "panleBody" }
const _hoisted_8 = {
  id: "composeSMS-details",
  class: "panelTabData scrollBar txtLeft",
  role: "tabpanel"
}
const _hoisted_9 = {
  id: "sms-dialog",
  style: {"font-size":"13px"}
}
const _hoisted_10 = { class: "row rowSms mb-3" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "row rowSms mb-3" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "row rowSms mb-3" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = {
  id: "sms-free-text-remaining",
  style: {"font-size":"x-small"}
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "row rowSms mb-3" }
const _hoisted_24 = { class: "col sms-non-enrolled-recipient" }
const _hoisted_25 = { class: "row rowSms mb-3" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "sms-preview-msg",
  class: "text-uppercase"
}, "SMS PREVIEW", -1))
const _hoisted_28 = { class: "row rowSms mb-3" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = {
  id: "modalLoadingDiv",
  class: "loadingDiv1",
  style: {"padding":"5px","display":"none"}
}
const _hoisted_31 = {
  id: "actionable-content-loading",
  style: {"text-align":"center"}
}
const _hoisted_32 = { class: "fa-2x" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin" }, null, -1))
const _hoisted_34 = { "aria-hidden": "true" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_36 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("a", {
            href: "#",
            class: "closeBtn neu-tooltip",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _createElementVNode("i", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'close'],
                size: "lg"
              })
            ]),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_neu_label, {
                    for: "sms-template",
                    class: "text-uppercase"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("sms template")
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("select", {
                    name: "ddlSmsTemplate",
                    class: _normalizeClass(['neu-select']),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshTemplate())),
                    placeholder: "Select Notification"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smsTemplates, (smsTemp) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: smsTemp.notificationTemplateId,
                        key: smsTemp.notificationTemplateId
                      }, _toDisplayString(smsTemp.name), 9, _hoisted_12))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedTemplate]
                  ]),
                  _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                    default: _withCtx(() => [
                      _createTextVNode("arrow_drop_down")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_neu_label, {
                    for: "sms-skill-deficit",
                    class: "text-uppercase"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("skill needed")
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("select", {
                    name: "ddlSkillNeeded",
                    class: _normalizeClass(['neu-select']),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSkill) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSkillChange())),
                    placeholder: "Select skill"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: skill.skillLevelId,
                        key: skill.skillLevelId
                      }, _toDisplayString(skill.description), 9, _hoisted_14))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedSkill]
                  ]),
                  _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                    default: _withCtx(() => [
                      _createTextVNode("arrow_drop_down")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_neu_label, {
                    for: "sms-shift",
                    class: "text-uppercase"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("shift")
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("select", {
                    name: "ddlShift",
                    class: _normalizeClass(['neu-select']),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedShift) = $event)),
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.refreshTemplate())),
                    placeholder: "Select Shift"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (shift) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: shift.deptShiftId,
                        key: shift.deptShiftId
                      }, _toDisplayString(shift.shiftText), 9, _hoisted_16))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedShift]
                  ]),
                  _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                    default: _withCtx(() => [
                      _createTextVNode("arrow_drop_down")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_neu_label, {
                    for: "sms-recipients",
                    class: "text-uppercase"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("RECIPIENTS")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VueMultiselect, {
                    modelValue: _ctx.selectedEnrolledRecipients,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedEnrolledRecipients) = $event)),
                      _ctx.enableSmsButton
                    ],
                    options: _ctx.enrolledRecipients,
                    multiple: true,
                    searchable: true,
                    "close-on-select": true,
                    placeholder: "Select Recipients",
                    label: "name",
                    "track-by": "name",
                    id: "selEnrolledRecipients"
                  }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_neu_label, {
                    for: "sms-free-text",
                    class: "text-uppercase"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ADD COMMENTS")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.smsFreeTextRemaining), 1),
                  _withDirectives(_createElementVNode("input", {
                    class: "neu-input__field",
                    id: "sms-free-text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.freeText) = $event)),
                    maxlength: "100",
                    type: "text",
                    autocomplete: "off",
                    style: {"min-height":"2.5rem !important"},
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFreeTextChange && _ctx.onFreeTextChange(...args))),
                    disabled: _ctx.isSMSFreeTextDisabled
                  }, null, 40, _hoisted_22), [
                    [_vModelText, _ctx.freeText]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_neu_label, {
                    for: "sms-non-enrolled-recipient",
                    class: "text-uppercase"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("NOT ENROLLED/UNSUBSCRIBED")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VueMultiselect, {
                    modelValue: _ctx.selectedUnenrolledRecipients,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedUnenrolledRecipients) = $event)),
                    options: _ctx.unenrolledRecipients,
                    multiple: true,
                    searchable: true,
                    "close-on-select": true,
                    placeholder: "",
                    label: "name",
                    "track-by": "name",
                    id: "selUnenrolledRecipients",
                    disabled: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.parsedSmsTemplate) = $event)),
                    id: "sms-preview-msg",
                    rows: "3",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.parsedSmsTemplate]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    class: "float-right",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isSendSMSDisabled ? null : _ctx.onSendSms())),
                    disabled: _ctx.isSendSMSDisabled
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" SEND SMS ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("i", _hoisted_34, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'filter'],
                        size: "lg"
                      })
                    ])
                  ]),
                  _hoisted_35
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}